import { RESOURCE } from '@src/constants';
import api from './api';

const checkUserDevice = async (fingerprint) => {
  const response = await api({
    method: 'POST',
    url: `${RESOURCE.DEVICES}/check`,
    data: { fingerprint },
    withCredentials: true,
  });
  return response;
};

const deactivateDevice = async (fingerprint) => {
  const response = await api({
    method: 'POST',
    url: `${RESOURCE.DEVICES}/deactivate`,
    data: { fingerprint },
  });
  return response;
};

const getDevices = async ({
  search,
  searchFields,
  offset,
  limit,
  fields,
  sort,
  query,
}) => {
  try {
    const response = await api({
      method: 'GET',
      url: RESOURCE.DEVICES,
      params: { search, searchFields, offset, limit, fields, sort, ...query },
    });
    return response;
  } catch (error) {
    return error.response?.data;
  }
};

const sendEmailConfirmLogoutDevices = async (email, deviceIds, type) => {
  const response = await api({
    method: 'POST',
    url: `${RESOURCE.DEVICES}/confirm-logout`,
    data: { email, deviceIds, type },
  });
  return response;
};

const logoutWithOTP = async (otp) => {
  try {
    const response = await api({
      method: 'POST',
      url: `${RESOURCE.DEVICES}/logout-devices-otp`,
      data: { otp },
    });

    return !!response.status;
  } catch (error) {
    return null;
  }
};

export {
  checkUserDevice,
  deactivateDevice,
  getDevices,
  sendEmailConfirmLogoutDevices,
  logoutWithOTP,
};
